export const SearchEndpoints = {
  root: '/search',
}
